/**
 * Created by @author @ddennis - ddennis.dk aka fantastisk.dk/works aka meresukker.dk on 30/06/2023.
 */
import React, { useEffect, useState } from 'react'
import Button from '../Button'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import useEmblaCarousel from 'embla-carousel-react'
import { useEmblaPagination } from '../useEmblaPagination'

const ClientGallery = ({ gallery }) => {
  const [show, setShow] = useState(false)

  const toogleView = () => {
    setShow(!show)
  }

  return (
    <div className="container-fluid my-5">
      <div className="row" style={{}}>
        <div className="col-12 col-md-12 mt-6">
          <p className="mb-md-2 mb-1 opacity-75 text-center">Bliv inspireret</p>
          <h3 className="fw-bold mb-3 text-center">Fantastiske kundeprojekter </h3>
        </div>

        <div className="col-10 col-md-6 mx-auto">
          <div className=" d-flex justify-content-center">
            <h6 className="mb-6 lh text-center  ">
              Lad dig inspirerer med billeder fra nogle af vores tidligere kunders projekter.
            </h6>
          </div>
        </div>
      </div>

      {gallery.map((item, index) => {
        return <GalleryItem key={index} data={item}></GalleryItem>
      })}

      <div className="row" style={{}}>
        {show ? (
          <div className="col-12 my-6">
            <div className="w-100 d-flex justify-content-center">
              <Button onClick={toogleView} className="py-3 px-6" title="Skjul kundeprojekter"></Button>
            </div>
          </div>
        ) : null}
      </div>
    </div>
  )
}
export default ClientGallery

const GalleryItem = ({ data }) => {
  /*const elRef = useBlazeSlider({
    // desktop
    '(min-width: 900px)': {
      slidesToShow: 3.5,
      slidesToScroll: 2,
      stopAutoplayOnInteraction: true,
      loop: false,
      enablePagination: true,
    },

    // phone
    '(max-width: 500px)': {
      slidesToShow: 1.5,
      enablePagination: false,
    },
  })*/

  const OPTIONS = {
    align: 'start',
    dragFree: true,
    //loop: true,
    slidesToScroll: 1,
    breakpoints: {
      '(min-width: 768px)': { slidesToScroll: 2 },
    },
  }

  const [emblaRef, emblaApi] = useEmblaCarousel(OPTIONS)

  const { selectedIndex } = useEmblaPagination(emblaApi)
  const clientImages = data.images

  useEffect(() => {
    console.log('KitchenCarousel > are embla ready ??? ')
    //if (emblaApi && emblaApi.slideNodes().length !== products.length) {
    if (emblaApi) {
      console.log('KitchenCarousel > YES EMBLA IS READY ')
      emblaApi.reInit() // Make Embla pick up changes in slide count
    }
  }, [emblaApi, clientImages])

  return (
    <>
      <div className="container mb-3" style={{ maxWidth: 1400 }}>
        <div className="embla row">
          <div className="embla__viewport col-12   " ref={emblaRef}>
            <div className="embla__container d-flex">
              {clientImages.map((item, index) => {
                const image = getImage(item)
                return (
                  <div
                    key={index}
                    className="embla__slide noselect me-3 rounded-3 overflow-hidden"
                    style={{ flex: '0 0 290px', minWidth: 0 }}
                  >
                    <GatsbyImage
                      key={index}
                      image={image}
                      alt={'model'}
                      className="ratio ratio-1x1 noselect"
                      imgStyle={{ objectPosition: '0% 0%', objectFit: 'cover' }}
                    />
                  </div>
                )
              })}
            </div>

            <div className="d-flex justify-content-center pt-2 pb-3 ">
              <div className="d-flex justify-content-center">
                {emblaApi?.scrollSnapList().map((item, index) => {
                  return (
                    <div
                      key={index}
                      className="mt-3 rounded-circle mx-1"
                      style={{
                        border: index === selectedIndex ? '3px solid black' : '1px solid black',
                        width: 12,
                        height: 12,
                        opacity: index === selectedIndex ? 1 : 0.3,
                      }}
                    ></div>
                  )
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
